module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Regular.19498325.ttf";